import { render } from "./TransitionLabel.vue?vue&type=template&id=1e62785d"
import script from "./TransitionLabel.vue?vue&type=script&lang=js"
export * from "./TransitionLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__